import './style.scss'

import createInview from '../common/js/inview.js'
import viewport from '../common/js/viewport.js'

import enter from '../common/js/enter.js'

import arrow from '../common/js/arrow.js'
import download from '../common/js/download.js'
import video from '../common/js/video.js'

const run = x => x()

const ready = () => {
  // create inview singleton, passing in an array of check functions
  const checkFuncs = [enter].map(func => func(viewport))

  createInview(checkFuncs)

  // setup other components
  ;[arrow, download, video].map(run)
}

export function initialize() {
  ready()
}
